var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"color":"primary","disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.sendSms}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }